import { useTheme } from "@mui/material";
import Box from "../../components/common/Box";
import { TextField } from "../../components/common/TextField";
import Typography from "../../components/common/Typography";

const PolicyName = ({ policyName, setPolicyName }) => {
  const theme = useTheme();
  const styles = {
    card: {
      width: "60%",
      padding: theme.spacing(2),
    },
  };
  return (
    <Box sx={styles.card}>
      <TextField
        value={policyName}
        onChange={(event) => {
          console.log({ d: event.target.value });
          setPolicyName(event.target.value);
        }}
        label="Policy Name"
        fullWidth={true}
      />
      <Typography variant="caption" color={theme.palette.surface50.main}>
        You can either keep the suggested name or click to customize and enter
        your own.
      </Typography>
    </Box>
  );
};

export default PolicyName;
